export default "__VITE_ASSET__2ae983e3__"